import { useEffect, useState } from 'react';
import GuestI from '../interfaces/Guest';
import AllAccessGuestI from '../interfaces/AllAccessGuest';
import getAge from '../functions/getAge';

const useAge = ({ dateOfBirth }: GuestI | AllAccessGuestI) => {
    const [age, setAge] = useState<number>(0);

    useEffect(() => {
        setAge(getAge(dateOfBirth as Date));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        age,
        setAge,
    };
};

export default useAge;
